import { Availability } from "../../types/availability";
import { APIResponseType } from "../../types/generics/APIResponse.type";
import { createDeleteApiHook, createPostApiHook } from "./apiHooks";

type EditAvailabilityParams = {
  talentId: number;
  id: number;
};

const deleteTalentAvailabilityEndpoint = ({
  talentId,
  id,
}: {
  talentId: number;
  id: number;
}) => `/users/talents/availability/${talentId}/${id}`;

const setEditTalentAvailabilityEndpoint = ({
  talentId,
  id,
}: {
  talentId: number;
  id: number;
}) => `/users/talents/availability/${talentId}/${id}`;

export const useEditTalentAvailability = createPostApiHook<
  {},
  EditAvailabilityParams,
  APIResponseType<Availability>
>(setEditTalentAvailabilityEndpoint, {
  isFormDataMethod: false,
});

export const useDeleteTalentAvailability = createDeleteApiHook<
  {},
  EditAvailabilityParams,
  APIResponseType<Availability>
>(deleteTalentAvailabilityEndpoint, {
  isFormDataMethod: false,
});
